// extracted by mini-css-extract-plugin
module.exports = {"pre-order-message":"uozAC","preOrderMessage":"uozAC"};